import React, {useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import {
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  InputLabel,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {read, utils} from 'xlsx';
import UploadIcon from '@material-ui/icons/CloudUpload';
import useStyles from './styles';
import ButtonSubmit from '../../components/forms/ButtonSubmit';
import {CloudDownload, Edit, Save} from '@material-ui/icons';
import {useSnackbar} from 'notistack';
import api from '../../core/api';
import Confirm from '../../components/Confirm';
import DeleteListBusinessItem from './deleteList';
import ShowEmailsDelete from '../../components/ShowEmailsDelete';

const DeleteUsers = ({history}) => {
  const classes = useStyles();
  const {enqueueSnackbar} = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [users, setUsers] = useState([]);

  const handleImport = $event => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = async event => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], {range: 2});
          setUsers(rows);
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleExport = () => {
    const link = document.createElement('a');
    link.href = '/Modelo_de_exclusao.xlsx';
    link.download = 'Modelo de exclusão (usuários B2B).xlsx';
    link.click();
  };

  async function onSubmit() {
    if (editable) {
      setEditable(false);
      return;
    }

    let statusOk = true;
    const payload = users.map(user => {
      if (statusOk) {
        if (!user['E-mail']) {
          enqueueSnackbar('Campo email não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        return {
          email: user['E-mail'].trim(),
        };
      }
    });

    if (statusOk) {
      const res = await Confirm('Deseja realmente excluir esses usuários?');

      if (res) {
        setIsLoading(true);
        try {
          await api
            .post('/business_users/emails', {emails: payload})
            .then(async ({data}) => {
              if (data.length <= 0) {
                enqueueSnackbar(
                  'Nenhum desses usuários foi encontrado ativo no sistema.',
                );
                return;
              }
              const res = await ShowEmailsDelete(data);
              if (res) {
                const normalizedEmails = payload.map(e =>
                  e.email.toLowerCase(),
                );

                await api.post('/business_users/unlink', {
                  emails: normalizedEmails,
                });
                enqueueSnackbar('Usuários desvinculados com sucesso!', {
                  variant: 'success',
                });
                history.push('/usuarios-empresa');
              }
            });
        } catch (error) {
          enqueueSnackbar('Erro ao deletar usuários, tente novamente!');
        } finally {
          setIsLoading(false);
        }
      }
    }
  }

  return (
    <Dashboard>
      <div className={classes.uploadsScreen}>
        <div className={classes.titleContainer}>
          <div className={classes.uploadBar}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}>
              <InputLabel>Baixar modelo da lista de exclusão</InputLabel>
              <IconButton
                variant="contained"
                component="label"
                onClick={handleExport}>
                <CloudDownload />
              </IconButton>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 20,
              }}>
              <InputLabel>Subir lista</InputLabel>
              <IconButton variant="contained" component="label">
                <UploadIcon />
                <input
                  type="file"
                  className={classes.fileInput}
                  required
                  onChange={handleImport}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </IconButton>
            </div>

            {users.length ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: 20,
                }}>
                <InputLabel>{`${
                  editable ? 'Ver' : 'Editar'
                } campos`}</InputLabel>
                <IconButton
                  variant="contained"
                  component="label"
                  onClick={() => setEditable(!editable)}>
                  {editable ? <Save /> : <Edit />}
                </IconButton>
              </div>
            ) : null}

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 20,
              }}>
              <InputLabel>Adicionar novo usuário</InputLabel>
              <IconButton
                variant="contained"
                component="label"
                onClick={() => {
                  const newUser = [
                    ...users,
                    {
                      'E-mail': '',
                    },
                  ];
                  setUsers(newUser);
                  setEditable(true);
                }}>
                <AddIcon />
              </IconButton>
            </div>
          </div>
        </div>

        <div className={classes.mediaItems}>
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em', justifyContent: 'center'}}>
                <CircularProgress size={100} />
                <p> Deletando usuários... </p>
              </span>
            </div>
          ) : users && users.length > 0 ? (
            <>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Email</TableCell>
                  </TableRow>
                </TableHead>

                <DeleteListBusinessItem
                  users={users}
                  editable={editable}
                  setUsers={setUsers}
                />
              </Table>
              {users.length ? (
                <ButtonSubmit
                  loadingArea={isLoading}
                  style={{marginTop: 20}}
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}>
                  Deletar
                </ButtonSubmit>
              ) : null}
            </>
          ) : (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em', justifyContent: 'center'}}>
                <p> Adicione usuários para exclusão </p>
              </span>
            </div>
          )}
        </div>
      </div>
    </Dashboard>
  );
};

export default DeleteUsers;
